// Menu item `name` keys to hide in the Tivita sidebar.
// Add keys here to remove items without rewriting Sidebar.vue structure.
export const HIDDEN_SIDEBAR_NAMES = new Set(['Captain']);

export function filterSidebarItems(items) {
  return items
    .filter(item => !HIDDEN_SIDEBAR_NAMES.has(item.name))
    .map(item =>
      item.children
        ? { ...item, children: filterSidebarItems(item.children) }
        : item
    )
    .filter(item => !item.children || item.children.length > 0);
}
